<template>
    <div class="nav-sidebar__wrapper">
        <div class="nav-sidebar-sport__tab-group sidebar_static__top">
            <div
                v-for="filter in filters"
                class="tab-item--terminal"
                :class="{'active': isSelected(filter.type)}"
                :key="filter.name"
                @click="onClick(filter.type)"
            >
                {{ filter.name | capitalize }}
            </div>
        </div>
        <component
            :is="filterComponent"
            :lottoNamespace="lottoNamespace"
        />
    </div>
</template>

<script>
    import i18n from '@app/localization/i18n';
    import { FilterType } from '@store/modules/ui/lotto/enums';
    import StoreUtil from '@app/store/StoreUtil';
    import LotteryFilterContainer from './LotteryFilterContainer.vue';
    import SystemFilterContainer from './SystemFilterContainer.vue';

    const filters = [
        {
            name: i18n.t('lotteries'),
            type: FilterType.lotteries
        },
        {
            name: i18n.t('systems'),
            type: FilterType.systems
        },
    ];
    export default {
        name: 'LottoFilterContainer',
        props: {
            lottoNamespace: {
                type: String,
                required: true,
            },
        },
        created() {
            this.filters = filters;
        },
        computed: {
            ...StoreUtil.mapGettersDynamic('lottoNamespace', [
                'isLotteryFilter',
                'isSystemFilter',
                'selectedFeaturedItem',
            ]),
            filterComponent() {
                return this.isLotteryFilter ? LotteryFilterContainer : SystemFilterContainer;
            }
        },
        methods: {
            ...StoreUtil.mapActionsDynamic('lottoNamespace', [
                'changeFilterUrl',
                'selectFeaturedLotteryGame',
            ]),
            isSelected(type) {
                return !this.selectedFeaturedItem
                    && ((this.isLotteryFilter && type === FilterType.lotteries)
                    || (this.isSystemFilter && type === FilterType.systems));
            },
            onClick(type) {
                this.changeFilterUrl(type);
                this.selectFeaturedLotteryGame(null);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/shared/lotto/LottoFilterContainer.vue